<script lang="ts" setup>
const { backgroundColor, widgetClass, className } = defineProps<{
  backgroundColor?: string
  className?: string
  widgetClass?: string
}>()
</script>

<template>
  <section
    :class="`widget-section ${widgetClass ?? ''}`"
    :style="{
      backgroundColor: backgroundColor ?? 'transparent',
    }">
    <div :class="{ 'm-auto max-w-xlg p-4 pb-6 lg:pb-12': true, [className]: Boolean(className) }">
      <slot />
    </div>
  </section>
</template>
